import type { FaireProductEntity } from "../../entity_types/product";

export const p_ad2fhakhhp: FaireProductEntity = {
  token: "p_ad2fhakhhp",
  type: "product",
  name: "Magnesium Bath Flakes, Bath Soak/Foot Soak With MSM",
  brandToken: "b_56mx5j1v94",
  brandName: "Magnum Solace",
  imageUrl:
    "https://cdn.faire.com/fastly/28665655598abb0fb1114697c7133223b3884249f3e2b7eeb8f40ad924cc672f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/907daa85fb69ef88fe89501a98b3bc25d54d7a6b89848179b1ab380fb98487cb.jpeg",
    "https://cdn.faire.com/fastly/3ba0e756b18465bb0f9d5e61bd0fed7256b73c055fb0d600873f089139d20b3f.jpeg",
    "https://cdn.faire.com/fastly/f33fa9268a401ae1f656c95e3a0627cb10bd919b87503f1a68a2f4c6f94d2c71.jpeg",
    "https://cdn.faire.com/fastly/fddd5646db384081d51e3eddc5551aaa850c8b772514e1500f4996efc28d01a9.png",
    "https://cdn.faire.com/fastly/33d5ebe4bfad24c745f9d1c41b75abc38c60423316ba78892486a27547f26798.png",
  ],
  priceDollars: 10,
  description:
    "Magnesium bath salts can help you feel better and sleep better. It's like bath bombs on steroids!   A magnesium bath soak takes just 20-30 minutes but you'll want more! It helps with restless legs, muscle soreness and improves sleep. In addition, MSM enhances potency, magnesium deliverability, encourages detox, joint and immune support! \n\n100% natural, single ingredients:\nIngredients: magnesium chloride flakes and msm\nQuantity: 10 lbs.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:22.790Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
